import type { SparklineGapPolicy } from '../types/sparkline-props.js';
import { isIsolatedAccessor } from './accessors.js';

export const shouldDisplayScatterPlot = (gapPolicy: SparklineGapPolicy) => {
  return gapPolicy === 'gap' ? isIsolatedAccessor : () => false;
};
